export const projects = [
  {
    title: "Clinic Management System",
    subtitle: "React and Spring Boot",
    description:
      "A simple clinic management system where patients can book appointments, doctors can conduct consultation and admin can add/edit the staff",
    image: "./cms.png",
    link: "https://main.d12c2lov5f3l0d.amplifyapp.com/",
  },
  {
    title: "Library Management System",
    subtitle: "Mongo Express Node",
    description:
      "A simple library management system project where we can select, update and generate report on books",
    image: "./Library.png",
    link: "https://johann-george.github.io/Library_management_project/",
  },
  {
    title: "Loan Management System",
    subtitle: "Angular and Spring Boot",
    description:
      "A website where users can request for loans and track their loan status",
    image: "./Loan.png",
    link: "https://johann-george.github.io/BankAppWebsite/",
  },
  {
    title: "Comprehensive wifi communication system",
    subtitle: "HTML,CSS,JavaScript and Langchain",
    description:  
      "Wi-Fi-based communication system tailored for educational institutions, combined with a Retrieval-Augmented Generation (RAG) based campus information retrieval chatbot and a live server for streaming.",
    image: "./chatbot-ui.png",
    link: "https://github.com/Johann-George/Comprehensive-wifi-communication-system",
  },
];

export const testimonials = [
  {
    quote:
      "I had the pleasure of working with Johann for over eight months at Nissan Digital’s IB4 (M&S Intelligence) department. From day one, he became a valuable part of the team. Johann showed strong skills in Python and Java and played a key role in implementing BDD in our product. He quickly understood the domain, picked up complex requirements, and turned them into clear, effective scenarios. His ability to learn fast and write clean, maintainable code stood out. He brought a great attitude to the team—always positive, curious, and ready to help. His passion for sports like cricket and football also added to his strong team spirit. Johann has a bright future in software development, and I’m happy to recommend him.",
    image: "./Ajesh-san.jpeg",
    name: "Ajesh CR",
    company: "Nissan Digital India",
  },
  {
    quote:
      "I had the opportunity to work with Johann for over six months at Nissan, and I was consistently impressed by his ability to take on challenges head-on with exceptional technical expertise. He played a key role in supporting our product through deep data analysis and single-handedly developed the BDD suite to ensure top-notch product quality. Beyond his professional contributions, Johann is also a passionate football player who brings great sportsmanship and teamwork to everything he does. I have no doubt that he will be a valuable asset to any team!",
    image: "./Hanoc-san.jpeg",
    name: "Hanoc George Varghese",
    company: "Nissan Digital India",
  },
];

export const skills = [
  "HTML/CSS",
  "Angular",
  "React",
  "Spring Boot",
  "Langchain",
  "Selenium",
];



// WEBPACK FOOTER //
// ./src/data.js